import { Component, OnInit } from '@angular/core';
import { CardService } from '../services/card.service';
import { Title, Meta } from '@angular/platform-browser';
import { SEOService } from '../services/seo.service';
import { ActivatedRoute } from '@angular/router';
import { RecaptchaErrorParameters } from "ng-recaptcha";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css',]
})
export class IndexComponent implements OnInit {

  name: string;
  email: string;
  service: string;
  message: string;
  contactInfoData = {};
 
  sendButton = 0;
  siteKey = '6LcVP90ZAAAAAPnZ0dhdaMYMDlXTJVhQ13CEdnJ2';
  
  title = 'Angular 10 Universal Example';
  constructor(
    private titleService: Title, 
    private metaService: Meta,
    private cardService: CardService,
    private actRoute: ActivatedRoute,
    private seo: SEOService
    ) { 
    console.log( this.actRoute.snapshot.routeConfig.component.name )
    this.seo.metaTags( String(this.actRoute.snapshot.routeConfig.component.name) );
    }

  ngOnInit(): void {
  }

  sendContactInfo(){

    if( this.name == "" || this.name== undefined || this.name == null || this.email == "" || this.email== undefined || this.email == null ) {
      alert('Completa los campos, por favor');
      return;
    }

    this.contactInfoData = {
      name: this.name,
      email: this.email,
      service: this.service,
      message: this.message,
      lang: 'esp'
    }

    this.cardService.emailInformation(this.contactInfoData).subscribe(response => {
      if(response.status === 1){
        alert('Información enviada')
      }else{
        alert('Ocurrio un error')
      }
    })

  }

  public resolved(captchaResponse: string): void {
    if(captchaResponse === null){
      this.sendButton = 0;
    }
    this.cardService.recaptchaVerification(captchaResponse).subscribe(response => {
      console.log(response)
      if(response.success === true){
        console.log('Recaptcha verification success 1');
        this.sendButton = 1;
      }else{
        console.log('Recaptcha verification success 0');
        this.sendButton = 0;
      }
    });
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    console.log('ONERROR')
    this.sendButton = 0;
  } 

}
